declare var $: any;
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormGroup } from '@angular/forms';
import { BaseComponent } from "../../base/base-component.component";
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { FieldReferenceModel } from "./FieldReferenceModel.model";
import { DynamicContentSchemaFactory, DynamicSchemaFactory, DynamicSchemaFacade, DynamicContentSchemaFacade,
  DynamicContentModel
} from "../../services/akita/index";
import { Schema, Content } from "../../services/squidex/index";

@Component({
  selector: 'app-field-reference-editor',
  templateUrl: 'field-reference-editor.component.html',
  styleUrls: ['field-reference-editor.component.css'],

  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FieldReferenceEditorComponent extends BaseComponent implements OnInit {
  
  @Input()
  fieldReferenceModel: FieldReferenceModel;
  
  contentsFacade: DynamicContentSchemaFacade;

  contents: Content[];

  constructor(
    translateService: TranslateService,
    private readonly dynamicContentSchemaFactory: DynamicContentSchemaFactory) {
    super(translateService);
    this.setTranslateContext("FieldReferenceEditor");
  }

  ngOnInit(): void {

    this.contentsFacade = this.dynamicContentSchemaFactory
      .getDynamicContentSchemaFacade(this.fieldReferenceModel.schemaDefinition.name);

    const sub = this.contentsFacade.getAll().subscribe(v => {
      this.contents = v;
    });

    this.subscriptions.push(sub);
  }

  onContentChanged(v) {
    if (!v) return;
    this.contents.push(v.value);
    //this.fieldReferenceModel.control.
    this.fieldReferenceModel.referenceFieldValues[this.fieldReferenceModel.field.name] =
      this.fieldReferenceModel.referenceFieldValues[this.fieldReferenceModel.field.name].concat(v.value);
  }
}
